<template>
  <div class="card-container">
    <el-button type="default" class="button-size" @click="$router.go(-1)"
      >返回</el-button
    >
    <el-button type="primary" class="button-size" @click="lodding()"
      >刷新物流</el-button
    >
    <el-row
      :gutter="20"
      style="margin-bottom: 20px"
      class="flow-wrap showInfoDialog"
    >
      <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
        <p>快递名称：{{ memInfo.expressName }}</p>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
        <p>快递单号：{{ memInfo.expressNo }}</p>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
        <p>快递刷新时间：{{ memInfo.expressUpdateTime }}</p>
      </el-col>
    </el-row>
    <common-table :data="tableData" ref="commonTable" :isShow="false">
      <el-table-column
        type="index"
        min-width="80"
        label="序号"
      ></el-table-column>
      <el-table-column
        prop="expressageTime"
        label="操作时间"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="expressageRemark"
        label="操作内容"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";

import MallService from "service/MallService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";
import TimeRange from "service/constant/TimeRange";

export default {
  name: "logisticsinfo",
  data() {
    return {
      submitService: MallService.logisticsInfoList,
      tableData: [],
      memInfo: {},
      orderId: "",
      isPage: false,
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  components: {
    CommonTopForm,
    CommonTable,
  },
  computed: {
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  mounted() {
    this.memInfo = JSON.parse(this.$route.params.logisticsinfoinfo);
    this.orderId = this.memInfo.id;
    this.$nextTick(() => {
      this.load();
    });
  },
  methods: {
    load() {
      this.getList();
    },
    getList() {
      const params = {
        orderId: this.orderId,
      };
      this.doLoad(
        this.submitService,
        params,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
          });
        },
        "信息获取失败"
      );
    },
    lodding() {
      const params = {
        orderId: this.orderId,
      };
      this.doLoad(
        this.submitService,
        params,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result;
      });
    },
  },
};
</script>

<style scoped>
.button-size {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/ShopManagement/LogisticsInfo.vue